import Cookies from 'vue-cookies'

// token
const TokenKey = 'Access-Token'
const H5TokenKey = 'Access-H5-Token'
const RefreshTokenKey = 'Refresh-Token'
const H5RefreshTokenKey = 'Refresh-H5-Token'
const WebSocketTokenKey = 'WebSocket-Token'
const Access = 'access'

export function setAccess(access) {
  return Cookies.set(Access, access)
}

export function getAccess(){
  return Cookies.get(Access)
}

export function getToken() {
  return Cookies.get(TokenKey)
}
export function getH5Token() {
  return Cookies.get(H5TokenKey)
}

export function setToken(token, expires_in) {
  return Cookies.set(TokenKey, token, expires_in)
}

export function setH5Token(token, expires_in) {
  return Cookies.set(H5TokenKey, token, expires_in)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeH5Token() {
  return Cookies.remove(H5TokenKey)
}

export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey)
}
export function getH5RefreshToken() {
  return Cookies.get(H5RefreshTokenKey)
}

// access
export function getAccessToken() {
  return Cookies.get(RefreshTokenKey)
}
export function getH5AccessToken() {
  return Cookies.get(H5RefreshTokenKey)
}

export function setAccessToken(token) {
  return Cookies.set(RefreshTokenKey, token, '30d')
}
export function setH5AccessToken(token) {
  return Cookies.set(H5RefreshTokenKey, token, '30d')
}

export function removeAccessToken() {
  return Cookies.remove(RefreshTokenKey)
}

export function removeH5AccessToken() {
  return Cookies.remove(H5RefreshTokenKey)
}

// =================WebSocket Token 操作=================
export function getWSToken() {
  return Cookies.get(WebSocketTokenKey)
}

export function setWSToken(token) {
  return Cookies.set(WebSocketTokenKey, token)
}

export function removeWSToken() {
  return Cookies.remove(WebSocketTokenKey)
}
